(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[171],{

/***/ "2Ufl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LineTitle; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("MWZw");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var LineTitle = function LineTitle(_ref) {
  var className = _ref.className,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["className"]);

  return __jsx(_frameworks_title_Title__WEBPACK_IMPORTED_MODULE_4__[/* Title */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()('mb-20', className),
    theme: "title-brand-n1"
  }));
};

/***/ }),

/***/ "ddrH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/widgets/line-title/LineTitle.jsx
var LineTitle = __webpack_require__("2Ufl");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("M+/F");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// EXTERNAL MODULE: ./src/client/components/utils/ratios/ratios.utils.js
var ratios_utils = __webpack_require__("u/u4");

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./src/i18n.js
var i18n = __webpack_require__("kiXb");

// EXTERNAL MODULE: ./src/client/tracking/tracking-api/useTracking.js
var useTracking = __webpack_require__("sRdV");

// EXTERNAL MODULE: ./src/client/components/frameworks/arrow-button/ArrowButton.jsx + 1 modules
var ArrowButton = __webpack_require__("Gy6l");

// EXTERNAL MODULE: ./src/client/components/frameworks/button/Button.jsx + 1 modules
var Button = __webpack_require__("e0Ti");

// EXTERNAL MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx + 1 modules
var Countdown = __webpack_require__("mmhe");

// EXTERNAL MODULE: ./src/client/components/frameworks/icon/Icon.jsx + 1 modules
var Icon = __webpack_require__("qBqs");

// EXTERNAL MODULE: ./src/client/components/frameworks/image/Image.jsx
var Image = __webpack_require__("0IQ5");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider/Slider.jsx + 1 modules
var Slider = __webpack_require__("ZFcn");

// EXTERNAL MODULE: ./src/client/components/frameworks/slider-handler/SliderHandler.jsx + 2 modules
var SliderHandler = __webpack_require__("A5Hi");

// EXTERNAL MODULE: ./src/client/components/frameworks/text/Text.jsx
var Text = __webpack_require__("qqKu");

// EXTERNAL MODULE: ./src/client/components/frameworks/title/Title.jsx + 1 modules
var Title = __webpack_require__("MWZw");

// CONCATENATED MODULE: ./src/client/components/widgets/event-animation/EventAnimation.jsx






var __jsx = react_default.a.createElement;

/* eslint-disable clubmed/no-fake-component */
















var EventAnimation_EventAnimation = function EventAnimation(_ref) {
  var offers = _ref.offers;
  var track = Object(useTracking["a" /* useTracking */])();

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isTablet = _useResponsive.isTablet;

  var hasMultipleOffers = offers.length > 1;

  var getTags = function getTags() {
    var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var countdown = arguments.length > 1 ? arguments[1] : undefined;

    if (!tags.length) {
      return [];
    }

    var maxNumberOfTags = (countdown === null || countdown === void 0 ? void 0 : countdown.dateTimeEnd) ? 1 : 2;
    var renderedTags = tags.map(function (_ref2) {
      var text = _ref2.text,
          theming = _ref2.theming;
      var backgroundColor = theming.backgroundColor,
          textColor = theming.textColor;
      return __jsx("div", {
        key: text,
        className: "bg-".concat(backgroundColor, " text-").concat(textColor, " leading-1 py-5 px-10 m-5 sm:m-0 sm:mx-0 sm:mb-10 rounded-2 font-bold text-12 uppercase flex items-center shadow-lg sm:shadow-none")
      }, __jsx("span", {
        className: "inline-block py-1"
      }, text));
    }).slice(0, maxNumberOfTags);

    var renderedCountdown = countdown && __jsx(Countdown["a" /* Countdown */], {
      bgColor: countdown.backgroundColor,
      className: "leading-1 text-12 m-5 sm:m-0 shadow-lg sm:shadow-none",
      color: countdown.textColor,
      dataTestId: "eventAnimation-countdown",
      dateTimeEnd: countdown.dateTimeEnd,
      days: countdown.days,
      hours: countdown.hours,
      minutes: countdown.minutes,
      seconds: countdown.seconds,
      theme: "offerPush"
    });

    return [].concat(Object(toConsumableArray["a" /* default */])(renderedTags), [renderedCountdown]);
  };

  var offerSlides = offers.map(function (_ref3) {
    var _visual$countdown;

    var content = _ref3.content,
        visual = _ref3.visual;
    var hasTags = Boolean(visual.tags.length || ((_visual$countdown = visual.countdown) === null || _visual$countdown === void 0 ? void 0 : _visual$countdown.dateTimeEnd));
    return __jsx("div", {
      key: content.title,
      className: "rounded-12 overflow-hidden relative bg-white h-full shadow-md sm:shadow-none flex flex-col sm:block",
      style: isTablet ? {
        minHeight: 'calc(360rem / 16)'
      } : {}
    }, __jsx("div", {
      className: classnames_default()('relative sm:static sm:h-full', {
        'h-full': !hasTags
      })
    }, __jsx("div", {
      className: "absolute top-0 start-0 bottom-0 pointer-events-none flex items-center justify-center bg-".concat(content.theming.backgroundColor),
      style: isTablet ? {
        width: '49%'
      } : {
        right: 0,
        left: 0
      }
    }, __jsx(Icon["a" /* Icon */], {
      name: content.icon,
      className: "opacity-10 shrink-0 relative end-1/2 ms-40",
      width: "calc(500rem / 16)",
      color: colors["a" /* COLORS */].WHITE
    })), __jsx("div", {
      className: "sm:w-5/6 mx-auto relative flex items-center h-full text-".concat(content.theming.textColor)
    }, __jsx("div", {
      className: "p-15 sm:py-20 sm:px-0"
    }, __jsx(Icon["a" /* Icon */], {
      name: content.icon,
      width: "calc(40rem / 16)"
    }), __jsx(Title["a" /* Title */], {
      hLevel: 3,
      className: "my-20 font-brand text-20",
      color: "inherit",
      theme: "none"
    }, content.title), __jsx(Text["a" /* Text */], {
      className: "text-inherit text-14 sm:text-16",
      text: content.description,
      theme: "none"
    }), __jsx("div", {
      className: "flex flex-wrap flex-col sm:flex-row items-center mt-30"
    }, __jsx(Text["a" /* Text */], {
      className: "text-inherit text-14 pb-10 sm:p-0 sm:pe-10 sm:me-auto",
      text: content.subtitle,
      theme: "none"
    }), content.button.label && content.button.url && __jsx(Button["a" /* Button */], {
      className: "shrink-0 mt-5",
      color: content.button.textColor,
      colorBg: content.button.backgroundColor,
      onClick: function onClick() {
        return track({
          actionGA: 'eventAnimation',
          labelGA: content.title
        });
      },
      url: content.button.url
    }, content.button.label))), isTablet && __jsx("div", {
      className: "w-3/5 shrink-0 ps-20 relative"
    }, hasTags && __jsx("div", {
      className: "absolute inset-0 px-40 py-20 flex flex-col items-start"
    }, getTags(visual.tags, visual.countdown)), __jsx(Image["a" /* Image */], {
      className: "-me-40 rounded-12 overflow-hidden",
      imageUrl: visual.imageUrl,
      ratioKey: ratios_utils["c" /* default */].M
    })))), !isTablet && hasTags && __jsx("div", {
      className: "flex items-center flex-wrap justify-center px-10 py-25 my-auto"
    }, getTags(visual.tags, visual.countdown)));
  });

  var getBottomControls = function getBottomControls(_ref4) {
    var index = _ref4.index,
        isNextControlDisabled = _ref4.isNextControlDisabled,
        isPreviousControlDisabled = _ref4.isPreviousControlDisabled,
        onNext = _ref4.onNext,
        onPrevious = _ref4.onPrevious;
    return __jsx("div", {
      className: "flex gap-20 items-center justify-center mt-20"
    }, __jsx(ArrowButton["a" /* ArrowButton */], {
      className: "flex-none text-8",
      color: colors["a" /* COLORS */].TRANSPARENT,
      isDisabled: isPreviousControlDisabled,
      label: Object(i18n["h" /* t */])('common.previous'),
      onClick: onPrevious,
      size: 12,
      theme: "ghost"
    }), __jsx("span", {
      className: "flex items-baseline justify-center text-12 text-black"
    }, __jsx("span", {
      className: "font-bold text-14"
    }, index + 1), "/", offers.length), __jsx(ArrowButton["a" /* ArrowButton */], {
      className: "flex-none text-8",
      color: colors["a" /* COLORS */].TRANSPARENT,
      isDisabled: isNextControlDisabled,
      label: Object(i18n["h" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180,
      size: 12,
      theme: "ghost"
    }));
  };

  var getScrollableTitles = function getScrollableTitles(activeIndex, onIndex) {
    var buttons = offers.map(function (_ref5, offerIndex) {
      var content = _ref5.content;
      var isActive = offerIndex === activeIndex;
      var color = content.theming.backgroundColor;
      return __jsx("button", {
        className: classnames_default()(["relative whitespace-nowrap sm:whitespace-normal pb-5 sm:mx-20 mb-20 text-14 text-".concat(color, " hocus:text-").concat(color, "-active")], {
          'font-bold': isActive,
          'ms-20': offerIndex !== 0
        }),
        key: content.title,
        onClick: function onClick(e) {
          onIndex(e, offerIndex);
        },
        type: "button"
      }, content.title, __jsx("div", {
        className: classnames_default()(["bg-".concat(color, " absolute top-full w-full scale-x-0 transition-transform")], {
          'transform scale-x-1': isActive
        }),
        style: {
          height: '2px'
        }
      }));
    });
    return !isTablet ? __jsx(Slider["a" /* Slider */], {
      cols: 0,
      hasControls: false,
      navPosition: "center",
      nbItemsToScroll: 1,
      initialIndex: activeIndex,
      nextLabel: Object(i18n["h" /* t */])('common.next'),
      previousLabel: Object(i18n["h" /* t */])('common.previous'),
      scrollAreaClassName: "overflow-hidden",
      scrollAreaContainerClassName: "overflow-auto scroll-x scrollbar-hidden snap-x snap-mandatory",
      scrollItemClassName: "overflow-hidden flex-none max-w-full"
    }, buttons) : __jsx("div", {
      className: "flex justify-center items-center"
    }, buttons);
  };

  return __jsx(SliderHandler["a" /* SliderHandler */], {
    hasKeyboardSupport: true,
    hasLazyload: true,
    hasSwipeSupport: true,
    className: classnames_default()('w-full rounded-12 sm:shadow-lg pb-10 sm:pb-0', {
      'pe-50 sm:pe-0': hasMultipleOffers
    }),
    items: offerSlides,
    spacerWidth: isTablet ? 0 : 10
  }, function (_ref6) {
    var hasControls = _ref6.hasControls,
        isNextControlDisabled = _ref6.isNextControlDisabled,
        isPreviousControlDisabled = _ref6.isPreviousControlDisabled,
        itemsNode = _ref6.itemsNode,
        index = _ref6.index,
        onNext = _ref6.onNext,
        onPrevious = _ref6.onPrevious,
        onIndex = _ref6.onIndex;
    return __jsx("div", null, hasMultipleOffers && getScrollableTitles(index, onIndex), __jsx("div", {
      className: "relative -mx-10 sm:mx-0"
    }, itemsNode, hasControls && isTablet && __jsx("div", {
      className: classnames_default()('absolute w-5/6 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-between pointer-events-none')
    }, __jsx(ArrowButton["a" /* ArrowButton */], {
      className: classnames_default()('flex-none -ms-20 shadow-sm pointer-events-auto transform ltr:-translate-x-full rtl:translate-x-full', {
        invisible: isPreviousControlDisabled
      }),
      color: colors["a" /* COLORS */].BLACK,
      isDisabled: isPreviousControlDisabled,
      label: Object(i18n["h" /* t */])('common.previous'),
      onClick: onPrevious,
      size: 40
    }), __jsx(ArrowButton["a" /* ArrowButton */], {
      className: classnames_default()('flex-none -me-20 shadow-sm pointer-events-auto transform ltr:translate-x-full rtl:-translate-x-full', {
        invisible: isNextControlDisabled
      }),
      color: colors["a" /* COLORS */].BLACK,
      isDisabled: isNextControlDisabled,
      label: Object(i18n["h" /* t */])('common.next'),
      onClick: onNext,
      rotation: 180,
      size: 40
    }))), hasMultipleOffers && getBottomControls({
      index: index,
      isNextControlDisabled: isNextControlDisabled,
      isPreviousControlDisabled: isPreviousControlDisabled,
      onNext: onNext,
      onPrevious: onPrevious
    }));
  });
};
// CONCATENATED MODULE: ./src/client/components/lines/event-animation-line/EventAnimationLine.jsx
var EventAnimationLine_jsx = react_default.a.createElement;




var EventAnimationLine_EventAnimationLine = function EventAnimationLine(_ref) {
  var items = _ref.items,
      title = _ref.title;
  return EventAnimationLine_jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line",
    "data-testid": "Line-EventAnimation"
  }, EventAnimationLine_jsx(LineTitle["a" /* LineTitle */], null, title), EventAnimationLine_jsx(EventAnimation_EventAnimation, {
    offers: items
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/event-animation/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (EventAnimationLine_EventAnimationLine);

/***/ }),

/***/ "mmhe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ Countdown_Countdown; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.pad-start.js
var es_string_pad_start = __webpack_require__("Jhhs");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/lodash/memoize.js
var memoize = __webpack_require__("pFSi");
var memoize_default = /*#__PURE__*/__webpack_require__.n(memoize);

// EXTERNAL MODULE: ./src/client/components/utils/color/colors.js
var colors = __webpack_require__("UCZK");

// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.themes.js





var defaultValueSizes = {
  small: {
    w: '2.3rem',
    valueTextSize: 'text-16',
    labelTextSize: 'text-8'
  },
  large: {
    w: '3.0625rem',
    valueTextSize: 'text-24',
    labelTextSize: 'text-10'
  }
};
var themes = {
  "default": memoize_default()(function (_ref) {
    var size = _ref.size,
        color = _ref.color;
    var textColor = color ? color : colors["a" /* COLORS */].WHITE;
    var textShadow = textColor === colors["a" /* COLORS */].WHITE ? 'text-shadow-2' : '';
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thItem: "flex flex-col items-center justify-between mx-5 text-center text-".concat(textColor),
      thValuesWrapper: 'flex flex-row',
      thLabel: "font-bold leading-1 mb-5 ".concat(textShadow, " uppercase ").concat(defaultValueSizes[size].labelTextSize),
      thValue: "flex font-bold items-center justify-center rounded-4 text-center ".concat(textShadow, " leading-tight ").concat(defaultValueSizes[size].valueTextSize),
      thValueStyle: {
        width: defaultValueSizes[size].w
      }
    };
  }),
  timer: memoize_default()(function (_ref2) {
    var size = _ref2.size,
        color = _ref2.color;
    return {
      thRoot: 'flex items-stretch justify-center text-14 mb-15',
      thDescription: "bg-".concat(color, " text-white shadow-sm py-5 px-10 mr-10 items-baseline"),
      thItem: "flex flex-row items-center justify-between text-center text-".concat(color),
      thLabel: 'items-baseline',
      thValuesWrapper: 'flex flex-row shadow-sm py-5 px-10 w-[7.5rem] justify-center',
      thValue: 'flex items-center justify-center rounded-4 text-center pl-5',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  }),
  offerPush: function offerPush(_ref3) {
    var _ref3$color = _ref3.color,
        color = _ref3$color === void 0 ? colors["a" /* COLORS */].WHITE : _ref3$color,
        bgColor = _ref3.bgColor;
    return {
      thRoot: classnames_default()("font-sans font-bold px-10 py-5 rounded-pill text-12 text-".concat(color), Object(defineProperty["a" /* default */])({}, "bg-".concat(bgColor), !!bgColor)),
      thItem: "inline mx-1 text-center text-".concat(color, " uppercase"),
      thValuesWrapper: 'flex flex-row py-1',
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: 'auto'
      }
    };
  },
  infoBanner: function infoBanner() {
    return {
      thRoot: 'font-brand px-5 rounded-2',
      thItem: 'flex mx-1 text-center text-14 uppercase',
      thValuesWrapper: 'flex flex-row',
      thLabel: 'inline',
      thValue: 'inline',
      thValueStyle: {
        width: '20px'
      }
    };
  },
  push: memoize_default()(function (_ref4) {
    var color = _ref4.color;
    return {
      thRoot: "font-brand text-".concat(color, " text-18 uppercase"),
      thValuesWrapper: 'flex',
      thItem: 'flex items-center leading-1 mx-2'
    };
  }),
  options: memoize_default()(function (_ref5) {
    var size = _ref5.size,
        color = _ref5.color;
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thDescription: 'font-bold text-saffron py-5 items-baseline',
      thItem: "flex flex-row items-baseline justify-between text-center text-".concat(color),
      thLabel: 'items-baseline text-14',
      thValuesWrapper: 'flex flex-row font-bold text-14 items-center',
      thValue: 'flex items-center justify-center rounded-4 text-center pl-5 text-14',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  }),
  optionDetails: memoize_default()(function (_ref6) {
    var size = _ref6.size,
        _ref6$color = _ref6.color,
        color = _ref6$color === void 0 ? colors["a" /* COLORS */].BLACK : _ref6$color;
    return {
      thRoot: 'flex ltr:flex-row rtl:flex-row-reverse items-stretch',
      thDescription: 'font-bold text-black py-5 items-baseline',
      thItem: "flex flex-col items-center text-".concat(color, " bg-pearl p-5 ml-5"),
      thLabel: 'items-baseline text-10 text-black',
      thValuesWrapper: 'flex flex-row font-bold text-18 items-center',
      thValue: 'flex items-center justify-center rounded-4 text-center pl-5 text-18',
      thValueStyle: {
        width: defaultValueSizes[size].labelTextSize
      }
    };
  })
};
// CONCATENATED MODULE: ./src/client/components/frameworks/countdown/Countdown.jsx







var __jsx = react_default.a.createElement;





function calculateTimeLeft(dateTimeEnd) {
  var now = moment_default()();
  return now.isBefore(dateTimeEnd) ? moment_default.a.duration(moment_default()(dateTimeEnd).diff(now)) : moment_default.a.duration(0);
}

function resolveTime(unit, roundToUnit, timeRemaining) {
  if (roundToUnit === unit) {
    switch (roundToUnit) {
      case 'days':
        return Math.floor(timeRemaining.asDays()).toString();

      case 'hours':
        return Math.floor(timeRemaining.asHours()).toString();

      case 'minutes':
        return Math.floor(timeRemaining.asMinutes()).toString();

      case 'seconds':
        return Math.floor(timeRemaining.asSeconds()).toString();

      default:
        return Math.floor(timeRemaining.asSeconds()).toString();
    }
  }

  return timeRemaining.get(unit).toString();
}

var Countdown_Countdown = function Countdown(_ref) {
  var bgColor = _ref.bgColor,
      className = _ref.className,
      color = _ref.color,
      dataTestId = _ref.dataTestId,
      dateTimeEnd = _ref.dateTimeEnd,
      description = _ref.description,
      expiredRender = _ref.expiredRender,
      _ref$roundToUnit = _ref.roundToUnit,
      roundToUnit = _ref$roundToUnit === void 0 ? 'days' : _ref$roundToUnit,
      _ref$showTimer = _ref.showTimer,
      showTimer = _ref$showTimer === void 0 ? true : _ref$showTimer,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'default' : _ref$theme,
      _ref$units = _ref.units,
      units = _ref$units === void 0 ? ['days', 'hours', 'minutes', 'seconds'] : _ref$units,
      _ref$updateFrequency = _ref.updateFrequency,
      updateFrequency = _ref$updateFrequency === void 0 ? 300 : _ref$updateFrequency,
      props = Object(objectWithoutProperties["a" /* default */])(_ref, ["bgColor", "className", "color", "dataTestId", "dateTimeEnd", "description", "expiredRender", "roundToUnit", "showTimer", "size", "theme", "units", "updateFrequency"]);

  var _useState = Object(react["useState"])(calculateTimeLeft(dateTimeEnd)),
      timeRemaining = _useState[0],
      setTimeRemaining = _useState[1];

  Object(react["useEffect"])(function () {
    var timer = setTimeout(function () {
      if (dateTimeEnd && timeRemaining.asSeconds() > 0) {
        setTimeRemaining(calculateTimeLeft(dateTimeEnd));
      }
    }, updateFrequency);
    return function () {
      return clearTimeout(timer);
    };
  }, [timeRemaining, dateTimeEnd]);
  var shouldDisplay = timeRemaining.asSeconds() > 0 && timeRemaining.months() === 0;

  if (!shouldDisplay) {
    if (dateTimeEnd && !!expiredRender) {
      return expiredRender;
    }

    return null;
  }

  if (!showTimer) {
    return null;
  }

  var _themes$theme = themes[theme]({
    color: color,
    size: size,
    bgColor: bgColor
  }),
      thItem = _themes$theme.thItem,
      thLabel = _themes$theme.thLabel,
      thRoot = _themes$theme.thRoot,
      thValue = _themes$theme.thValue,
      thDescription = _themes$theme.thDescription,
      thValueStyle = _themes$theme.thValueStyle,
      thValuesWrapper = _themes$theme.thValuesWrapper;

  return __jsx("div", {
    className: classnames_default()(className, thRoot),
    role: "timer",
    "data-testid": dataTestId
  }, description && __jsx("div", {
    className: thDescription
  }, description), __jsx("div", {
    className: thValuesWrapper
  }, units.map(function (unit) {
    var currentTime = resolveTime(unit, roundToUnit, timeRemaining);
    var transformedCurrentTime = currentTime.padStart(2, '0');
    return __jsx("div", {
      className: thItem,
      key: unit
    }, __jsx("div", {
      className: thValue,
      style: thValueStyle
    }, transformedCurrentTime), __jsx("div", {
      className: thLabel
    }, " ", props[unit]));
  })));
};

/***/ })

}]);